import "./Contact.css";

const CONTACT_ITEMS = [
  {
    label: "Email",
    value: "agbotonaugustin@gmail.com",
    href: "mailto:agbotonaugustin@gmail.com",
  },
  {
    label: "Telephone",
    value: "06 66 25 99 80",
    href: "tel:+33666259980",
  },
  {
    label: "Disponibilite",
    value: "immediatement",
  },
];

export default function Contact() {
  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <div className="contact-shell">
          <div className="contact-copy contact-copy-full reveal-up">
            <span className="contact-kicker">Parlons de votre projet</span>
            <h2 className="contact-title">Contactez-moi</h2>
            <p className="contact-subtitle">
              Une question, une mission ou une collaboration en tete ?
              Ecrivez-moi ou appelez-moi directement.
            </p>

            <div className="contact-availability-card">
              <span className="contact-availability-badge">
                Recherche d'alternance
              </span>
              <h3>Disponible immediatement</h3>
              <p>
                Je suis actuellement a la recherche d'une alternance et je peux
                echanger rapidement sur une opportunite.
              </p>
            </div>

            <div className="contact-info-list">
              {CONTACT_ITEMS.map((item, index) => (
                <div
                  key={item.label}
                  className="contact-info-item"
                  style={{ animationDelay: `${index * 120}ms` }}
                >
                  <span className="contact-info-label">{item.label}</span>
                  {item.href ? (
                    <a href={item.href} className="contact-info-value">
                      {item.value}
                    </a>
                  ) : (
                    <span className="contact-info-value">{item.value}</span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
